import { Backdrop, Button, ButtonProps, CircularProgress } from '@mui/material';

interface Props extends ButtonProps {
  isLoading?: boolean;
  onClick?: () => void;
}

export const SubmitButton: React.FC<Props> = ({ children, isLoading, onClick, ...rest }) => {
  return (
    <>
      <Backdrop sx={theme => ({ zIndex: theme.zIndex.drawer + 1 })} open={!!isLoading} invisible />
      <Button
        variant="contained"
        sx={{ flex: 1 }}
        color="primary"
        fullWidth
        {...rest}
        onClick={evt => {
          evt.preventDefault();
          if (onClick) {
            onClick();
          }
        }}
      >
        {isLoading ? <CircularProgress size={24} /> : children}
      </Button>
    </>
  );
};
